module.exports = __webpack_public_path__ + "img/sortBy-arrow-gray.6d9e0d66.svg";